import type { StaffShiftSummary } from "../../../api/staffApi";

function labelForShift(shift: Pick<StaffShiftSummary, "status" | "requestStatus" | "assignmentStatus" | "calledOut">) {
  if (shift.calledOut) return { text: "Called out", tone: "muted" as const };
  if (shift.assignmentStatus === "active") return { text: "Assigned", tone: "success" as const };
  if (shift.requestStatus === "pending") return { text: "Request pending", tone: "warning" as const };
  if (shift.requestStatus === "approved") return { text: "Approved", tone: "success" as const };
  if (shift.requestStatus === "declined") return { text: "Declined", tone: "danger" as const };
  if (shift.status === "open") return { text: "Open", tone: "accent" as const };
  if (shift.status === "cancelled") return { text: "Cancelled", tone: "muted" as const };
  return { text: shift.status.replace(/_/g, " "), tone: "muted" as const };
}

type ShiftStatusBadgeProps = {
  shift: Pick<StaffShiftSummary, "status" | "requestStatus" | "assignmentStatus" | "calledOut">;
};

export function ShiftStatusBadge({ shift }: ShiftStatusBadgeProps) {
  const { text, tone } = labelForShift(shift);
  return <span className={`staff-badge staff-badge--${tone}`}>{text}</span>;
}
